import { Box } from '@mui/material';
import { Footer } from './Footer';
import { Navbar } from './Navbar';
import { BackgroundEffects } from '../ui';
import type { ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
}

export const PageContainer = ({ children }: PageContainerProps) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        color: 'text.primary',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <BackgroundEffects />
      <Navbar />
      <Box
        component="main"
        id="main-content"
        sx={{
          flexGrow: 1,
          pt: { xs: 8, md: 10 },
          position: 'relative',
          zIndex: 1,
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
};
